module.exports = __webpack_public_path__ + "static/img/animation.fe3ed93.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ordering/animation.gif
// module id = NcZi
// module chunks = 4